module.exports = __webpack_public_path__ + "assets/img/67_213_3.ff995132.jpg";